import { ContentOnlyLayout } from '@/layouts/ContentOnlyLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { getGenericStaticPaths } from '@/utils/nextUtils/staticPages'
import { loadTranslations } from '@/utils/translate/translate-server'
import { ParentalControlsFeedbackView } from '@/views/ParentalControlsFeedbackView'

const ParentalControlsFeedbackPage: NextPageWithLayout = () => {
  return <ParentalControlsFeedbackView />
}

export const getStaticPaths = getGenericStaticPaths

export const getStaticProps = getStaticPropsErrorHandler(
  { filePath: 'pages/[locale]/feedback/parental-controls/index.tsx' },
  async ({ locale }) => {
    return {
      props: {
        locale,
        ...(await loadTranslations(locale, ['common', 'feedback'])),
      },
      revalidate: 3600,
    }
  },
)

ParentalControlsFeedbackPage.getLayout = (page) => {
  return <ContentOnlyLayout>{page}</ContentOnlyLayout>
}

export default ParentalControlsFeedbackPage
